import React from 'react'
import { withRouter } from 'react-router-dom'
import { withAuthentication } from '../Session'
import { compose } from 'recompose'
import FormComponent from '../Form'
import { Container } from 'semantic-ui-react'
import form from './config/job-form'
import { AutoHeader } from '../Common'

class VideoJobPage extends React.Component {
   render() {
      return (
         <Container>
            <AutoHeader />
            <Container>
               <FormComponent form={form} {...this.props} />
            </Container>
         </Container>
      )
   }
}

export default compose(withRouter, withAuthentication)(VideoJobPage)
